import { AboSubscriptionOrderProductCustomField } from './AboSubscriptionOrderProductCustomField';

export class AboSubscriptionOrderProduct {
    id?: string;
    title?: string;
    productNumber: number;
    quantity: number;
    createdOn: Date;
    validFrom: Date;
    validTo: Date;
    minRuntime?: number;
    maxRuntime?: number;
    nettPrice?: number;
    commissionModelId?: string;
    deliveries?: number;
    intervalMonth?: number;
    nextBilling?: string;
    subscriptionOrderProductCustomFields: AboSubscriptionOrderProductCustomField[];
    currencyIso: string;

    constructor(json: any) {
        this.id = json.id;
        this.title = json.title;
        this.productNumber = json.productNumber;
        this.quantity = json.quantity;
        this.createdOn = json.createdOn;
        this.validFrom = json.validFrom;
        this.validTo = json.validTo;
        this.minRuntime = json.minRuntime;
        this.maxRuntime = json.maxRuntime;
        this.nettPrice = json.nettPrice;
        this.commissionModelId = json.commissionModelId;
        this.deliveries = json.deliveries;
        this.intervalMonth = json.intervalMonth;
        this.nextBilling = json.nextBilling;
        this.subscriptionOrderProductCustomFields = json.subscriptionOrderProductCustomFields;
        this.currencyIso = json.currencyIso || 'EUR';
    }
}
